import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  CircularProgress,
} from "@mui/material";
import ModalHeader from "./ModalHeader";
import StyledTextField from "./StyledTextField";
import { styled } from "@mui/system";
import { ModalFooter } from "./ModalFooter";
import { ActionButton } from "../shared/action-button";
import ArticleIcon from '@mui/icons-material/Article';

const Content = styled(DialogContent)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  padding: "16px",
  backgroundColor: theme.colors.primaryBackground,
  color: "white",
}));

const ShareStudiesModal = ({ open, onClose, studies, onSubmit, loading }) => {
  const [selectedStudies, setSelectedStudies] = useState([]);
  const [targetEmail, setTargetEmail] = useState("");
  const [numberOfDays, setNumberOfDays] = useState("30");

  const handleToggle = (studyId) => {
    setSelectedStudies((prev) =>
      prev.includes(studyId)
        ? prev.filter((id) => id !== studyId)
        : [...prev, studyId]
    );
  };

  const handleSubmit = () => {
    onSubmit([selectedStudies, targetEmail, numberOfDays]);
    setSelectedStudies([]);
    setTargetEmail("");
    setNumberOfDays("30");
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <ModalHeader title={`Share Studies`} onClose={onClose} icon={<ArticleIcon />} />
      <Content>
        <StyledTextField
          label="Recipient Email"
          fullWidth
          variant="outlined"
          size="small"
          value={targetEmail}
          onChange={(e) => setTargetEmail(e.target.value)}
        />
        <StyledTextField
          label="Access Days"
          type="number"
          fullWidth
          variant="outlined"
          size="small"
          value={numberOfDays}
          onChange={(e) => setNumberOfDays(e.target.value)}
        />

        <List>
          {studies.map((study) => (
            <ListItem key={study.StudyInstanceUID} disablePadding>
              <ListItemIcon>
                <Checkbox
                  checked={selectedStudies.includes(study.StudyInstanceUID)}
                  onChange={() => handleToggle(study.StudyInstanceUID)}
                  sx={{
                    color: "white",
                    "&.Mui-checked": {
                      color: "white",
                    },
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary={`${new Date(study.StudyDate).toLocaleDateString(
                  "en-US",
                  { year: "numeric", month: "2-digit", day: "2-digit" }
                )} - ${study.Modality || ""} - ${study.StudyDescription || "No Description"
                  }`}
              />
            </ListItem>
          ))}
        </List>
      </Content>

      <ModalFooter>
        <ActionButton variantType="outlined" colorType="negative" onClick={onClose}>
          Cancel
        </ActionButton>
        <ActionButton
          variant="contained"
          onClick={handleSubmit}
          disabled={
            loading ||
            selectedStudies.length === 0 ||
            !targetEmail ||
            !numberOfDays
          }
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : "Share"}
        </ActionButton>
      </ModalFooter>
    </Dialog>
  );
};

export default ShareStudiesModal;
